import {AfterViewInit, Component, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {EditQuestionModel} from '../../shared/edit-question.model';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {Subscription} from 'rxjs/Subscription';
import {FormBuilder, FormGroup, FormsModule, Validators} from '@angular/forms';
import {isNullOrUndefined} from 'util';

@Component({
  selector: 'app-edit-quiz',
  templateUrl: './edit-quiz.component.html',
  styleUrls: ['./edit-quiz.component.css']
})
export class EditQuizComponent implements OnInit , AfterViewInit {

  private route$: Subscription;
  selectedQuiz: object;
  newOption: object;
  questionId: any;
  selectedQuestion: any;
  editQuiz: FormGroup;
  loading: boolean;
  openNewOption: boolean;
  quizId: any;
  quizQuestion: any;
  updateOptionObject: object;
  constructor(private httpClient: HttpClient, private route: ActivatedRoute, private forms: FormsModule,
              private formBuilder: FormBuilder, private router: Router,
  ) {
    this.initializeForm();
  }

  ngOnInit() {
    this.route$ = this.route.params.subscribe(
      (params: Params) => {
        this.questionId = params['id'];
      });
    this.selectedQuestion = [];
    this.getSelectedQuiz();
    this.loading = true;
    this.newOption = {
      explanation: '',
      id: 0,
      isActive: true,
      isCorrect: true,
      option: '',
      quizId: null,
    };
  }
  ngAfterViewInit() {

  }
  getSelectedQuiz() {
    this.loading = true;
    this.httpClient.get('http://ec2-18-223-41-152.us-east-2.compute.amazonaws.com:8080/v1/quiz/quiz/options/' + this.questionId)
      .subscribe((data: EditQuestionModel) => {
        console.log('Question', data);
        this.selectedQuiz = {
              difficultyId: data.data.quiz.difficultyId,
              examId: data.data.quiz.examId,
              id: data.data.quiz.id,
              isActive: data.data.quiz.isActive,
              position: data.data.quiz.position,
              question: data.data.quiz.question,
              subjectId: data.data.quiz.subjectId,
              tags: data.data.quiz.tags,
              timeCreated: data.data.quiz.timeCreated,
              timeModified: data.data.quiz.timeModified,
              yearId: data.data.quiz.yearId,
              videoId: data.data.quiz.videoId
        };
        console.log('Question2', this.selectedQuiz);
        this.quizId = this.selectedQuiz['id'];
        this.quizQuestion = this.selectedQuiz['question'];
        console.log('Prepopulator2', this.quizId, this.quizQuestion);
        this.getSelectedQuizOptions();
    });
  }

  getSelectedQuizOptions() {
    if (this.quizId) {
    this.httpClient.get('http://ec2-18-223-41-152.us-east-2.compute.amazonaws.com:8080/v1/quiz/quizOption/list/quiz/' + this.quizId)
      .subscribe((data: EditQuestionModel) => {
        this.selectedQuestion = data.data;
        console.log('PrepopulatorOptions', this.selectedQuestion);
        this.loading = false;
      });
  }}

  /**
   * method to build the reactive form.
   */
  initializeForm() {
    this.editQuiz = this.formBuilder.group({
      questions: ['', Validators.compose([Validators.required])],
      options: ['', Validators.compose([Validators.required])],
      explanations: ['', Validators.compose([Validators.required])]

    });
  }
  previous() {
   this.questionId = this.questionId - 1;
    console.log(this.questionId);
    this.router.navigate([ '../quiz/edit-quiz/' + this.questionId ]);
    this.getSelectedQuiz();
  }
  next() {
    this.questionId = parseInt(this.questionId, 0) + 1;
    console.log(this.questionId);
    this.router.navigate([ '../quiz/edit-quiz/' + this.questionId ]);
    this.getSelectedQuiz();

  }
  updateQuestion(question) {
    this.loading = true;
    console.log(question);
    if (isNullOrUndefined(question) || question === '') {
      return;
    }
    this.selectedQuiz['question'] = question;
    console.log('New Question Object', this.selectedQuiz);
    this.httpClient.put('http://ec2-18-223-41-152.us-east-2.compute.amazonaws.com:8080/v1/quiz', this.selectedQuiz)
      .subscribe((response) => {
        console.log('Response', response);
        if (response['status'] === 'Success') {
          this.loading = false;
          this.getSelectedQuiz();
        } else {
          this.loading = false;
        }
      });

  }

  updateOption(details, description, option) {
    console.log('Option', option);
    console.log('Description', description);
    console.log('Old Object', details);
    if (isNullOrUndefined(description) || description === ' ') {
    description = details.explanation;
    }
    if (isNullOrUndefined(option) || option === ' ') {
      option = details.option;
    }
    this.updateOptionObject = {
      explanation : description,
      id: details.id,
      isActive: details.isActive,
      isCorrect: details.isCorrect,
      option: option,
      quizId: details.quizId
    };
    console.log('newObject', this.updateOptionObject);
      this.httpClient.put('http://ec2-18-223-41-152.us-east-2.compute.amazonaws.com:8080/v1/quiz/quizOption', this.updateOptionObject)
        .subscribe((response) => {
console.log('Response', response);
this.loading = false;
this.getSelectedQuiz();
        });
  }
  addNewOption(explanation, option) {
    this.newOption = {
      explanation: explanation,
      id: 0,
      isActive: true,
      isCorrect: true,
      option: option,
      quizId: this.selectedQuiz['id']
    };
    console.log('Option', this.newOption);
    this.httpClient.post('http://ec2-18-223-41-152.us-east-2.compute.amazonaws.com:8080/v1/quiz/quizOption', this.newOption)
      .subscribe((response) => {
        console.log('Response', response);
        this.loading = false;
        this.getSelectedQuiz();
      });
    this.openNewOption = false;
  }
  openNewSpace() {
    this.openNewOption = true;
    console.log('OpenNewOption', this.openNewOption);
  }
  deleteOption(option) {
    console.log('Option', option.id);
    // this.httpClient.delete('http://ec2-18-223-41-152.us-east-2.compute.amazonaws.com:8080/v1/quiz/quizOption/' + option.id)
    //   .subscribe((response) => {
    //     console.log('Response', response);
    //     this.loading = false;
    //     this.getSelectedQuiz();
    //   });

  }
}



// WEBPACK FOOTER //
// ./src/app/edit-quiz/edit-quiz.component.ts